import React, { ChangeEvent, useState } from 'react'

import {
  NewsletterButton,
  NewsletterContainer,
  NewsletterForm,
  NewsletterInput,
  NewsletterMessage,
  NewsletterTitle,
} from './newsletter-subscription.styles'

export const NewsletterSubscription = () => {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  /**
   * HIGHLIGHT: handle submit
   * This function is used to handle the submit event of the newsletter form.
   * It will send the email and tags? to the server and show a success or error message.
   * @param e - React.FormEvent<HTMLFormElement>
   * @returns void
   */
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<() => void> => {
    e.preventDefault()

    try {
      setIsLoading(true)
      await fetch('/api/subscribe', {
        body: JSON.stringify({
          email,
          // Tag used to identify newsletter subscribers in the MailChimp dashboard.
          // It's not mandatory, but using a tag is recommended for better segmentation.
          // NOTE: We must create this tag manually in the MailChimp dashboard beforehand.
          // Random or non-existent tags will not be supported.
          tags: ['Newsletter'],
        }),
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
      })

      setMessage('Thank you for subscribing!')
      setIsSuccess(true)
      setEmail('')
      setIsLoading(false)
    } catch (error) {
      setMessage('Failed to subscribe. Please try again.')
      setIsSuccess(false)
      setIsLoading(false)
    }

    // Clear success message after 3 seconds
    const timeout = setTimeout(() => {
      setMessage('')
    }, 3000)

    return () => clearTimeout(timeout)
  }

  /**
   * HIGHLIGHT: handle email change
   * This function is used to handle the change event of the email input.
   * It will set the email to the state.
   * @param e - ChangeEvent<HTMLInputElement>
   * @returns void
   */
  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value)
  }

  return (
    <NewsletterContainer>
      <NewsletterTitle>Subscribe to Our Newsletter</NewsletterTitle>
      <NewsletterForm onSubmit={handleSubmit}>
        <NewsletterInput
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={handleEmailChange}
          required
        />
        <NewsletterButton type="submit" $loading={isLoading}>
          Subscribe
        </NewsletterButton>
      </NewsletterForm>
      {message && <NewsletterMessage success={isSuccess}>{message}</NewsletterMessage>}
    </NewsletterContainer>
  )
}
